import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom'
import { dateTimeToView } from '../../../../utils/date.utils';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useMediaQuery, useTheme } from '@mui/material';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { ELibraryManagementApi, list_borrow } from '../../../../api/e-library/e_library_management';
import StatusCustom from '../../../../components/status/statusCustom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { routeName } from '../../../../routes/routeName';
import { alertActive, alertSuccess } from '../../../../components/alert/swal';
import { LIBRARY_HISTORY_STATUS } from '../../enum/elibrary_enum';
import { renderDate } from '../../../../utils/app.utils';


export const useManageState = () => {
    // CONSTANCE
    const location = useLocation();
    const path_name = location.pathname;
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();
    const navigate = useNavigate();


    // HOOKS
    const [key_search, set_key_search] = useState<number>(1);
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("library_history_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);
    const [library_history_status, set_library_history_status] = useState<any>(null);
    const [step, set_step] = useState<number>(0);

    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_start_date(st);
        set_end_date(end);
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const handleClearFilter = () => {
        set_start_date("");
        set_end_date("");
        set_library_history_status(null);
        set_search("");
        set_key_search((prev) => prev + 1);
        setPage(1);
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อหนังสือ")
        },
        ...(step === 0 ? [
            {
                id: "ๅ", disablePadding: false, align: "center", width: 140, label: t("เลขเรียกหนังสือ") // i18n-ignore
            },
            {
                id: "1", disablePadding: false, align: "center", width: 141, label: t("ผู้ยืม")
            },
            {
                id: "2", disablePadding: false, align: "center", width: 141, label: t("วันที่ยืม")
            },
            {
                id: "3", disablePadding: false, align: "center", width: 141, label: t("วันที่คืน")
            },
            {
                id: "action", disablePadding: false, align: "center", margin: "0 2em", width: 180, class: matches && data.length > 0, label: t("สถานะ")
            },
        ] : [
            {
                id: "A", disablePadding: false, align: "center", width: 140, label: t("ชื่อ-นามสกุลผู้ยืม")
            },
            {
                id: "B", disablePadding: false, align: "center", width: 140, label: t("เบอร์โทร")
            },
            {
                id: "V", disablePadding: false, align: "center", width: 140, label: t("เวลาที่จอง")
            },
            {
                id: "D", disablePadding: false, align: "center", width: 140, label: t("วันที่จอง")
            },
        ])
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {

            id_library_history,
            library_head_name,
            library_detail_number,
            full_name,
            library_history_date,
            library_history_status,
            phone_number,
            library_history_return_date,
            library_history_booked_date
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "left",
                    label: library_head_name || "-",
                },
                ...(step === 0 ? [
                    {
                        option: "TEXT",
                        align: "center",
                        label: library_detail_number || "-",
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: full_name || '-'
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: library_history_date ? dateTimeToView(library_history_date) : '-'
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: library_history_return_date ? dateTimeToView(library_history_return_date) : '-'
                    },
                    {
                        option: "COMPONENT",
                        align: "center",
                        class: matches && data.length > 0,
                        component: <div className='flex px-2 justify-between items-center'>
                            <span className='w-full flex justify-start items-center'>
                                <StatusCustom
                                    disableMaxWidth
                                    sx={{ maxWidth: "fit-content", px: 2 }}
                                    text={library_history_status || ""}
                                    type={library_history_status || ""}
                                />
                            </span>
                            <span>
                                <OptionsButtonCustom
                                    enableEdit
                                    enableView
                                    enableDelete={LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW === library_history_status}
                                    onViewClick={() => {
                                        id_library_history && navigate(routeName.e_library.manage_borrow_view.replace(":id", id_library_history));
                                    }}
                                    onEditClick={() => {
                                        id_library_history && navigate(routeName.e_library.manage_borrow_detail.replace(":id", id_library_history));
                                    }}
                                    onDeleteClick={() => id_library_history && handleDeleteBorrow(id_library_history)}
                                />
                            </span>
                        </div>
                    },
                ] : [
                    {
                        option: "TEXT",
                        align: "center",
                        label: full_name || "-",
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: phone_number || "-",
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: library_history_booked_date ? moment(library_history_booked_date).format("HH:mm") : "-",
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: library_history_booked_date ? renderDate(library_history_booked_date) : "-",
                    },
                ])
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleDeleteBorrow = (id_library_history: number) => {
        alertActive(t("ลบรายการ"), t("ต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading())
            await ELibraryManagementApi.deleteBorrow(id_library_history).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ สำเร็จ"));
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }


    const handleGetData = useCallback(async () => {
        let query: list_borrow = {
            page: page,
            limit: pageLimit,
            sortBy,
            sortType
        }
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.end_date = moment(end_date).format("YYYY-MM-DD");
        if (search) query.search = search
        if (library_history_status) query.library_history_status = library_history_status?.value;
        if (step === 1) query.is_booked = 1
        dispatch(setLoading());
        await ELibraryManagementApi.listBorrow(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                set_data(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, start_date, end_date, search, library_history_status, step])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        path_name,
        set_search,
        handleChangeDateRange,
        start_date,
        end_date,
        page,
        pageLimit,
        totalItems,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        library_history_status,
        set_library_history_status,
        set_step,
        step,
        handleClearFilter,
        key_search
    }
}

